import { c as _c } from "react/compiler-runtime";
import { faPlusCircle, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from 'shared/tooltip';
import setFieldTouched from 'final-form-set-field-touched';
import React from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { useDispatch, useSelector } from 'react-redux';
import { LabeledCheckbox } from 'shared/checkbox';
import Autocomplete from '../autocomplete';
import Button from '../button';
import FormError from '../form-error';
import { Box, Flex, Grid } from '../grid';
import InfoIcon from '../info-icon';
import Input from '../input';
import InputGroup from '../input-group';
import Label from '../label';
import { fetchDataList, fetchDataLists } from '../redux/data-lists/actions';
import Select from '../select';
import Switch from '../switch';
import { Link } from '../typography';
import { useIsDatalistValid } from './hooks';
export const FieldPrefixContext = React.createContext('');
export const LabelField = t0 => {
  const $ = _c(2);
  const {
    prefix
  } = t0;
  const t1 = prefix ? `${prefix}.label` : "label";
  let t2;
  if ($[0] !== t1) {
    t2 = <Field name={t1} validate={_temp}>{_temp2}</Field>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const PlaceholderField = t0 => {
  const $ = _c(2);
  const {
    prefix
  } = t0;
  const t1 = prefix ? `${prefix}.placeholder` : "placeholder";
  let t2;
  if ($[0] !== t1) {
    t2 = <Field name={t1}>{_temp3}</Field>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const HelpTextField = t0 => {
  const $ = _c(2);
  const {
    prefix
  } = t0;
  const t1 = prefix ? `${prefix}.helptext` : "helptext";
  let t2;
  if ($[0] !== t1) {
    t2 = <Field name={t1}>{_temp4}</Field>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const PrivateField = t0 => {
  const $ = _c(2);
  const {
    prefix
  } = t0;
  const t1 = prefix ? `${prefix}.private` : "private";
  let t2;
  if ($[0] !== t1) {
    t2 = <Field name={t1} type="checkbox">{_temp5}</Field>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const NameField = t0 => {
  const $ = _c(9);
  const {
    prefix,
    isUniqueFieldName,
    removable
  } = t0;
  const t1 = prefix ? `${prefix}.name` : "name";
  let t2;
  if ($[0] !== isUniqueFieldName || $[1] !== removable) {
    t2 = (value_0, values) => {
      if (!value_0) {
        return "Enter a field name";
      }
      if (value_0.match(/[^0-9a-zA-Z_$]/)) {
        return "A field name may only contain letters, numbers, and '_'";
      }
      if (["business_id", "client_id", "form_id", "id"].includes(value_0)) {
        return `${value_0} is reserved and cannot be used`;
      }
      if (removable && !isUniqueFieldName(value_0, values.id)) {
        return `Another field named "${value_0}" id is already used`;
      }
    };
    $[0] = isUniqueFieldName;
    $[1] = removable;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== removable) {
    t3 = t4 => {
      const {
        input,
        meta
      } = t4;
      return <Box><Input {...input} label={<>Field name{" "}<InfoIcon value="A unique identifier that can be used to reference this field" /></>} disabled={!removable} type="text" error={meta.touched && meta.error} /></Box>;
    };
    $[3] = removable;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <Field parse={_temp6} name={t1} validate={t2}>{t3}</Field>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const RequiredField = t0 => {
  const $ = _c(2);
  const {
    prefix
  } = t0;
  const t1 = prefix ? `${prefix}.required` : "required";
  let t2;
  if ($[0] !== t1) {
    t2 = <Field name={t1}>{_temp7}</Field>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const ClientFieldReference = t0 => {
  const $ = _c(13);
  const {
    prefix,
    schema
  } = t0;
  const clientSchema = useSelector(_temp8);
  let t1;
  if ($[0] !== clientSchema || $[1] !== schema.type) {
    let t2;
    if ($[3] !== schema.type) {
      t2 = s => s.type === schema.type;
      $[3] = schema.type;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = clientSchema.filter(t2).map(_temp9);
    $[0] = clientSchema;
    $[1] = schema.type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const options = t1;
  let t2;
  if ($[5] !== clientSchema) {
    t2 = clientSchema.reduce(_temp0, {});
    $[5] = clientSchema;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const valueToLabel = t2;
  const t3 = prefix ? `${prefix}.associated_client_field_name` : "associated_client_field_name";
  let t4;
  if ($[7] !== options || $[8] !== valueToLabel) {
    t4 = t5 => {
      const {
        input,
        meta
      } = t5;
      return <Box><Label mb={2} invalid={meta.touched && meta.error}>Link to client field{" "}<InfoIcon value="When the form is submitted, this client field will be updated" /></Label><InputGroup><Autocomplete {...input} sx={{
            display: "block",
            width: "100%"
          }} invalid={meta.touched && meta.error} itemToString={v => valueToLabel[v] || ""} items={options} />{input.value && <Button onClick={e => input.onChange("")}>Unlink</Button>}</InputGroup>{meta.error && meta.touched && <FormError>{meta.error}</FormError>}</Box>;
    };
    $[7] = options;
    $[8] = valueToLabel;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Field name={t3}>{t4}</Field>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export const DataSourceField = t0 => {
  const $ = _c(19);
  const {
    prefix
  } = t0;
  const values = useFormState().values;
  const dispatch = useDispatch();
  const businessId = useSelector(_temp1);
  let t1;
  let t2;
  if ($[0] !== businessId || $[1] !== dispatch) {
    t1 = () => {
      dispatch(fetchDataLists({
        businessId
      }));
    };
    t2 = [businessId, dispatch];
    $[0] = businessId;
    $[1] = dispatch;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  React.useEffect(t1, t2);
  const dataListData = useSelector(_temp10);
  let t3;
  if ($[4] !== dataListData) {
    t3 = Object.values(dataListData);
    $[4] = dataListData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== businessId || $[7] !== t3) {
    t4 = t3.filter(l => l.business_id === businessId).map(_temp11);
    $[6] = businessId;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const dataListsItems = t4;
  const dataSource = prefix ? values[prefix].data_source : values.data_source;
  const t5 = prefix ? `${prefix}.data_source` : "data_source";
  let t6;
  if ($[9] !== t5) {
    t6 = <Box><Field name={t5}>{_temp12}</Field></Box>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dataListData || $[12] !== dataListsItems || $[13] !== dataSource || $[14] !== prefix) {
    t7 = dataSource === "data_list_id" ? <Box><Label mb={2}>Data list</Label><Field name={prefix ? `${prefix}.data_list_id` : "data_list_id"}>{t8 => {
          const {
            input: input_0,
            meta: meta_0
          } = t8;
          return <><Box><Autocomplete {...input_0} truncate={100} items={dataListsItems} itemToString={v => dataListData[v]?.label || ""} /></Box>{meta_0.touched && meta_0.error && <FormError>{meta_0.error}</FormError>}</>;
        }}</Field></Box> : <Box><Label mb={2}>Options</Label><FieldArray name={prefix ? `${prefix}.options` : "options"}>{_temp14}</FieldArray></Box>;
    $[11] = dataListData;
    $[12] = dataListsItems;
    $[13] = dataSource;
    $[14] = prefix;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export const useOptionItems = schema => {
  const $ = _c(17);
  const dispatch = useDispatch();
  const dataListData = useSelector(_temp15);
  let t0;
  if ($[0] !== dataListData || $[1] !== schema.data_list_id || $[2] !== schema.data_source) {
    t0 = schema.data_source === "data_list_id" ? (dataListData[schema.data_list_id]?.items || []).reduce(_temp16, {}) : {};
    $[0] = dataListData;
    $[1] = schema.data_list_id;
    $[2] = schema.data_source;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const valueToDescription = t0;
  let t1;
  if ($[4] !== dataListData || $[5] !== schema.data_list_id || $[6] !== schema.data_source || $[7] !== schema.options) {
    t1 = schema.data_source === "data_list_id" ? (dataListData[schema.data_list_id]?.items || []).map(_temp17) : (schema.options || []).map(_temp18);
    $[4] = dataListData;
    $[5] = schema.data_list_id;
    $[6] = schema.data_source;
    $[7] = schema.options;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const items = t1;
  let t2;
  let t3;
  if ($[9] !== dispatch || $[10] !== items.length || $[11] !== schema.data_list_id) {
    t2 = () => {
      if (schema.data_list_id && items.length === 0) {
        dispatch(fetchDataList(schema.data_list_id));
      }
    };
    t3 = [dispatch, schema.data_list_id, items.length];
    $[9] = dispatch;
    $[10] = items.length;
    $[11] = schema.data_list_id;
    $[12] = t2;
    $[13] = t3;
  } else {
    t2 = $[12];
    t3 = $[13];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[14] !== items || $[15] !== valueToDescription) {
    t4 = [items, valueToDescription];
    $[14] = items;
    $[15] = valueToDescription;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
function _temp(value) {
  if (!value) {
    return "Enter a label";
  }
}
function _temp2(t0) {
  const {
    input,
    meta
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp2" data-sentry-source-file="shared.tsx"><Input {...input} label="Label" type="text" error={meta.touched && meta.error} data-sentry-element="Input" data-sentry-source-file="shared.tsx" /></Box>;
}
function _temp3(t0) {
  const {
    input,
    meta
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp3" data-sentry-source-file="shared.tsx"><Input {...input} label={<>Placeholder text{" "}<InfoIcon value="Placeholder text that appears when the field is empty" /></>} error={meta.touched && meta.error} type="text" data-sentry-element="Input" data-sentry-source-file="shared.tsx" /></Box>;
}
function _temp4(t0) {
  const {
    input,
    meta
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp4" data-sentry-source-file="shared.tsx"><Input {...input} label={<>Help text{" "}<InfoIcon value="Provides guidance as to how to fill in this field" /></>} type="text" error={meta.touched && meta.error} data-sentry-element="Input" data-sentry-source-file="shared.tsx" /></Box>;
}
function _temp5(t0) {
  const {
    input,
    meta
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp5" data-sentry-source-file="shared.tsx"><Label data-sentry-element="Label" data-sentry-source-file="shared.tsx"><LabeledCheckbox {...input} mr={2} label="For office use only (not visible to clients)" data-sentry-element="LabeledCheckbox" data-sentry-source-file="shared.tsx" />{meta.touched && meta.error && <FormError>{meta.error}</FormError>}</Label></Box>;
}
function _temp6(value) {
  return value?.toLowerCase?.();
}
function _temp7(t0) {
  const {
    input
  } = t0;
  return <Flex alignItems="center" data-sentry-element="Flex" data-sentry-component="_temp7" data-sentry-source-file="shared.tsx"><Switch size="small" {...input} data-sentry-element="Switch" data-sentry-source-file="shared.tsx" /><Box ml={2} data-sentry-element="Box" data-sentry-source-file="shared.tsx">Required</Box></Flex>;
}
function _temp8(state) {
  return state.businesses.data[state.userPreferences.currentBusinessId].client_schema;
}
function _temp9(s_0) {
  return {
    value: s_0.name,
    label: s_0.label
  };
}
function _temp0(agg, cur) {
  agg[cur.name] = cur.label;
  return agg;
}
function _temp1(state) {
  return state.userPreferences.currentBusinessId;
}
function _temp10(state_0) {
  return state_0.dataLists.data;
}
function _temp11(t0) {
  const {
    id,
    label
  } = t0;
  return {
    value: id,
    label
  };
}
function _temp12(t0) {
  const {
    input
  } = t0;
  return <Select {...input} label="List source" data-sentry-element="Select" data-sentry-component="_temp12" data-sentry-source-file="shared.tsx"><option value="options">Options list</option><option value="data_list_id">Data list</option></Select>;
}
function _temp13(value) {
  if (!value) {
    return "Enter ";
  }
}
function _temp14(t0) {
  const {
    fields
  } = t0;
  return <Grid data-sentry-element="Grid" data-sentry-component="_temp14" data-sentry-source-file="shared.tsx">{fields.map((name, index) => <Field key={index} name={name} validate={_temp13}>{t1 => {
        const {
          input: input_1,
          meta: meta_1
        } = t1;
        return <Box><Input {...input_1} type="text" invalid={meta_1.touched && meta_1.error} suffix={<Tippy content="Remove"><Link color="alert" as="button" type="button" onClick={() => fields.remove(index)}><FontAwesomeIcon icon={faTrash} /></Link></Tippy>} />{meta_1.error && meta_1.touched && <FormError>{meta_1.error}</FormError>}</Box>;
      }}</Field>)}<Link as="button" type="button" onClick={() => fields.push("")} data-sentry-element="Link" data-sentry-source-file="shared.tsx"><FontAwesomeIcon icon={faPlusCircle} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="shared.tsx" /> Add option</Link></Grid>;
}
function _temp15(state) {
  return state.dataLists.data;
}
function _temp16(agg, v) {
  agg[v.value] = v.description;
  return agg;
}
function _temp17(v_0) {
  return {
    label: `${v_0.description} - ${v_0.value}`,
    value: v_0.value
  };
}
function _temp18(v_1) {
  return {
    label: v_1,
    value: v_1
  };
}